import { useEffect } from 'react';

export default function useOutsideClick(ref, callback, shouldAttach = true) {
  useEffect(() => {
    const clickOutsideHandler = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };
    if (shouldAttach) {
      document.addEventListener('click', clickOutsideHandler);
    }
    return () => {
      document.removeEventListener('click', clickOutsideHandler);
    };
  }, [ref, callback, shouldAttach]);
}